import { render } from "./ModalError.vue?vue&type=template&id=fd12b3f0"
import script from "./ModalError.vue?vue&type=script&lang=js"
export * from "./ModalError.vue?vue&type=script&lang=js"

import "./ModalError.vue?vue&type=style&index=0&id=fd12b3f0&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__